
import { Component, Prop, Vue } from "vue-property-decorator";

type ButtonState = "ready" | "busy" | "success" | "error" | "disabled";

@Component
export default class AppTileButton extends Vue {
  @Prop() buttonState!: ButtonState;

  @Prop() buttonClass!: string;

  @Prop({ default: false }) showInfoIcon!: boolean;

  @Prop({ default: "" }) infoButtonClass!: string;

  @Prop() tabindex?: number;

  name: String = "AppTileButton";

  get buttonColour(): String {
    switch (this.buttonState) {
      case "ready":
        return "primary";
      case "busy":
        return "secondary";
      case "success":
        return "success";
      case "error":
        return "error";
      case "disabled":
        return "secondary";
      default:
        return "";
    }
  }

  get isDarkTheme(): boolean {
    return this.buttonColour !== "secondary";
  }

  get stateClass(): string {
    return this.buttonState === "disabled" ? "app-tile-button--disabled" : "";
  }

  onClickCard() {
    if (this.buttonState === "busy" || this.buttonState === "disabled") {
      return;
    }
    this.$emit("onclick");
  }

  onClickWrapper() {
    if (this.buttonState === "disabled") {
      this.$emit("onclick-disabled");
    }
  }

  onClickInfo() {
    this.$emit("onclick-info");
  }
}

export { AppTileButton, ButtonState };
